import { z } from 'zod';
import BaseContainer from '../../../Packages/block-container';
const ContainerPropsSchema = z.object({
    style: BaseContainer.schema.shape.style,
    props: z
        .object({
        childrenIds: z.array(z.string()).optional().nullable(),
    })
        .optional()
        .nullable(),
});
export default ContainerPropsSchema;
//# sourceMappingURL=ContainerPropsSchema.js.map